import { isNull } from "lodash";
import { APIs } from "../../../../../../util/api/APIs";
import SafeairManager from "../../../../../../util/api/SafeairManager";
import { APIUserType } from "./types/APIUserType";
import { OrganizationType } from "./types/OrganizationType";
import { UserFromFileType } from "./types/UserFromFileType";
import { UserType } from "./types/UserType";

class UsersService {
  async listUsers() {
    const usersListResponse = await SafeairManager.invoke({
      api: APIs.User.ListAllUsers,
      parameters: null,
      body: null,
    });

    const users_ = usersListResponse.data.users as APIUserType[];
    console.log('did not user response')
    console.log(JSON.stringify(users_));
const users: UserType[] = users_.map((apiUser) => {
      const obj = {} as { [key: string]: string };
      apiUser.attributes.forEach((attr) => {
        obj[attr.name] = attr.value;
      });
      obj["username"] = apiUser.username;
      return { ...obj, enabled: apiUser.enabled, userStatus: apiUser.userStatus } as UserType;
    });
    console.log('got user response')
    console.log(JSON.stringify(users));
    return users;
  }

  async exportUsersPdf() {
    const response = await SafeairManager.invoke({
      api: APIs.User.ExportPdf,
      parameters: null,
      body: null,
    });
  
    return response;
  }
  async exportOrgPdf(organizationId: string) {
    const response = await SafeairManager.invoke({
      api: APIs.User.OrgPdf,
      parameters: { organizationId },
      body: null,
    });
  
    return response;
  }

  async listUsersByUsername(username: string) {
    const users = await SafeairManager.invoke({
      api: APIs.User.ListAllUsersByUsername,
      parameters: {
        username,
    
      },
      body: null,
    });

    const usersByUsername = users.data.users as APIUserType[];

    const user: UserType[] = usersByUsername.map((apiUser) => {
      const obj = {} as { [key: string]: string };
      apiUser.attributes.forEach((attr) => {
        obj[attr.name] = attr.value;
      });
      obj["username"] = apiUser.username;
      return { ...obj, enabled: apiUser.enabled,userStatus: apiUser.userStatus } as UserType;
    });

    return user;
    // return users.data.users as APIUserType[];
  }

  async updateUserByAdmin(body: {
    username: string;
    email: string;
    name: string;
    familyName: string;
    customType: string;
    gender: string;
    phoneNumber?: string;
    enableNotification?:string;
  }) {
    const users = await SafeairManager.invoke({
      api: APIs.User.updateUserAttributesByAdmin,
      parameters: null,
      body:body
    });
    return users;
  }


  async updateConfirmStatus(
    isApproved: string,username:string) {
    const users = await SafeairManager.invoke({
      api: APIs.User.updateUserStatus,
      parameters: {
        username,
        isApproved
      },
      body:null
    });
    return users;
  }

  async createUser(body: {
    username: string;
    email: string;
    name: string;
    familyName: string;
    customType: string;
    gender: string;
    organizationId: number;
    phoneNumber?: number;
  }) {
    const userCreationResponse = await SafeairManager.invoke({
      api: APIs.User.CreateUser,
      parameters: null,
      body,
    });
    return userCreationResponse.data;
  }

  async batchUserCreation(users: UserFromFileType[]) {
    await Promise.all(
      users.map((user) => {
        return SafeairManager.callWithRetry(this.createUser, {
          username: user.username,
          email: user.email,
          name: user.name,
          familyName: user.last_name,
          customType: user.profile,
          gender: user.gender,
          ...(user.phoneNumber ? { phoneNumber: user.phoneNumber } : {}),
        });
      })
    );
  }

  async assignPermissionToUser(userId: string, permissionCode: string) {
    const response = await SafeairManager.invoke({
      api: APIs.User.AssignPermission,
      parameters: {
        "user-id": userId,
      },
      body: APIs.User.AssignPermission.BODY_TYPE({
        permissionCode: permissionCode,
      }),
    });
    return response.data;
  }

  async assignPermissionsToUsers(userIds: string[], permissionCodes: string[]) {
    await Promise.all(
      userIds.map((userId) => {
        return Promise.all(
          permissionCodes.map((permissionCode) => {
            return this.assignPermissionToUser(userId, permissionCode);
          })
        );
      })
    );
  }

  async revokePermissionsFromUser(userId: string, permissionCodes: string[]) {
    await Promise.all(
      permissionCodes.map((permissionCode) => {
        const response = SafeairManager.invoke({
          api: APIs.User.RevokePermission,
          parameters: {
            "user-id": userId,
            "permission-code": permissionCode,
          },
          body: null,
        });
        return response;
      })
    );
  }

  async assignRolesToUsers(userIds: string[], roleCodes: string[]) {
    await Promise.all(
      userIds.map((userId) => {
        return Promise.all(
          roleCodes.map((roleCode) => {
            return this.assignRoleToUser(userId, roleCode);
          })
        );
      })
    );
  }

  async assignRoleToUser(userId: string, roleCode: string) {
    const response = await SafeairManager.invoke({
      api: APIs.User.AssignRole,
      parameters: {
        "user-id": userId,
      },
      body: APIs.User.AssignRole.BODY_TYPE({
        roleCode: roleCode,
      }),
    });
    return response.data;
  }

  async revokeRolesFromUser(userId: string, roleCodes: string[]) {
    await Promise.all(
      roleCodes.map((roleCode) => {
        const response = SafeairManager.invoke({
          api: APIs.User.RevokeRole,
          parameters: {
            "user-id": userId,
            "role-code": roleCode,
          },
          body: null,
        });
        return response;
      })
    );
  }

  async disableUsers(userIds: string[]) {
    const disableRequests = userIds.map((userId) => {
      const response = SafeairManager.invoke({
        api: APIs.User.DisableUser,
        parameters: {
          "user-id": userId,
        },
        body: null,
      });
      return response;
    });
    await Promise.all(disableRequests);
  }

  async getUserRoles(userId: string) {
    const response = SafeairManager.invoke({
      api: APIs.User.GetUserRoles,
      parameters: {
        "user-id": userId,
      },
      body: null,
    });
    return (await response).data;
  }

  async getUserbyOrganizationId(orgId: string) {
    const response = await SafeairManager.invoke({
      api: APIs.Organization.getUserByOrganizationId,
      parameters: {
        "organization-id": orgId,
      },
      body: null,
    });
    const users_ = response.data as APIUserType[];

    const users: UserType[] = users_.map((apiUser) => {
      const obj = {} as { [key: string]: string };
      apiUser.attributes.forEach((attr) => {
        obj[attr.name] = attr.value;
      });
      obj["username"] = apiUser.username;
      return { ...obj, enabled: apiUser.enabled,userStatus: apiUser.userStatus } as UserType;
    });
    return users;
  }

  async getUserPermissions(userId: string) {
    const response = SafeairManager.invoke({
      api: APIs.User.GetUserPermissions,
      parameters: {
        "user-id": userId,
      },
      body: null,
    });
    return (await response).data;
  }

  async listOrganizations() {
    const response = SafeairManager.invoke({
      api: APIs.Organization.ListAllOrganizations,
      parameters: null,
      body: null,
    });
    return (await response).data as OrganizationType[];
  }

  async listAllFlights() {
    const response = SafeairManager.invoke({
      api: APIs.Flight.GetAllFlights,
      parameters: null,
      body: null,
    });
    return (await response).data ;
  }

  async getWifiProvider() {
    const response = SafeairManager.invoke({
      api: APIs.Flight.GetWifiProvider,
      parameters: null,
      body: null,
    });
    return (await response).data ;
  }

  async saveDeviceToken(id: string, deviceToken: string | null) {
    const response = await SafeairManager.invoke({
      api: APIs.User.saveDeviceToken,
      parameters: null,
      body: APIs.User.saveDeviceToken.BODY_TYPE({
        id: id,
        deviceToken: deviceToken
      }),
    });
    return response.data;
  }

  async getDeviceToken(id: string) {
    const response = await SafeairManager.invoke({
      api: APIs.User.getDeviceToken,
      parameters: {
        username: id
      },
      body: null
    });
    console.log("response", response);
    return response.data;
  }

  async resendMail(username: string | undefined, email: string | undefined) {
    console.log(username,email)
    const response = await SafeairManager.invoke({
      api: APIs.User.resendEmail,
      parameters: {
        username: username,
        email: email
      },
      body: null
    });
    console.log("response", response);
    return response.data;
  }

}

export default new UsersService();
